var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-1" } }, [
      _c("h2", { staticClass: "mb-10" }, [
        _vm._v("Bitácora " + _vm._s(_vm.anio))
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Vehículo *" } },
              [
                _c(
                  "v-select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    class: {
                      "v-select-danger": _vm.errors.has(
                        "custom-document-part-1.vehicle"
                      )
                    },
                    attrs: {
                      "data-cy": "vehicle",
                      "data-vv-as": "vehículo",
                      name: "vehicle",
                      options: _vm.optionsVehicles
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "spinner",
                        fn: function() {
                          return [
                            _vm.isLoadVehiclesOptions
                              ? _c("b-spinner", {
                                  style: {
                                    opacity: _vm.isLoadVehiclesOptions ? 1 : 0
                                  },
                                  attrs: { small: "", variant: "primary" }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.formData.vehicle,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "vehicle", $$v)
                      },
                      expression: "formData.vehicle"
                    }
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v(" no hay vehículos para el criterio de búsqueda ")
                    ])
                  ],
                  2
                ),
                _vm.errors.has("custom-document-part-1.vehicle")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-1.vehicle"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-5 ml-5" },
          [
            _c("list-user", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "driver",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Conductor *",
                name: "driver",
                "data-cy": "driver",
                "data-vv-as": "conductor",
                danger: _vm.errors.has("custom-document-part-1.driver"),
                "danger-text": _vm.errors.first(
                  "custom-document-part-1.driver"
                ),
                "group-filter": _vm.driverGroupId
              },
              model: {
                value: _vm.formData.driver,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "driver", $$v)
                },
                expression: "formData.driver"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-2" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("add-destinations", {
              on: { "add-destination": _vm.addDestination }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("table-destinations", {
              attrs: { destinations: _vm.formData.destinations, multiple: "" },
              model: {
                value: _vm.formData.destinationsSelected,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "destinationsSelected", $$v)
                },
                expression: "formData.destinationsSelected"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-3" } }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Objetivo del cometido *" } },
              [
                _c("b-form-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has(
                      "custom-document-part-3.objectiveTask"
                    )
                      ? false
                      : null,
                    "data-cy": "objective-task",
                    "data-vv-as": "objetivo del cometido",
                    name: "objectiveTask",
                    type: "text",
                    rows: "3",
                    maxLength: "5000"
                  },
                  model: {
                    value: _vm.formData.objectiveTask,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "objectiveTask", $$v)
                    },
                    expression: "formData.objectiveTask"
                  }
                }),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formData.objectiveTask.length) +
                          "/5000 "
                      )
                    ]
                  )
                ]),
                _vm.errors.has("custom-document-part-3.objectiveTask")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-3.objectiveTask"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-4" } }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("select-passengers", {
              on: { "add-passenger": _vm.addPassenger }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("table-passengers", {
              attrs: { passengers: _vm.formData.passengers, multiple: "" },
              model: {
                value: _vm.formData.passengersSelected,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "passengersSelected", $$v)
                },
                expression: "formData.passengersSelected"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-5" } }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(2),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("add-charge-gasoline", {
              on: { "add-charge-gasoline": _vm.addChargeGasoline }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 mt-3" },
          [
            _c("table-charge-gasoline", {
              attrs: {
                loadsGasoline: _vm.formData.loadsGasoline,
                multiple: ""
              },
              model: {
                value: _vm.formData.loadsGasolineSelected,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "loadsGasolineSelected", $$v)
                },
                expression: "formData.loadsGasolineSelected"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "custom-document-part-6" } }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(3),
        _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Conductor" } },
              [
                _c("b-form-input", {
                  attrs: {
                    "data-cy": "incident-driver",
                    name: "incidentDriver",
                    type: "text",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.incidentDriver,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "incidentDriver", $$v)
                    },
                    expression: "formData.incidentDriver"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6 mt-3" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Rut" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "validateRut",
                      expression: "'validateRut'"
                    }
                  ],
                  attrs: {
                    "data-cy": "incident-driver-iut",
                    name: "incidentDriverIut",
                    type: "text",
                    state: _vm.errors.has(
                      "custom-document-part-6.incidentDriverIut"
                    )
                      ? false
                      : null,
                    placeholder: "12345678-9"
                  },
                  model: {
                    value: _vm.formData.incidentDriverIut,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "incidentDriverIut", $$v)
                    },
                    expression: "formData.incidentDriverIut"
                  }
                }),
                _vm.errors.has("custom-document-part-6.incidentDriverIut")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document-part-6.incidentDriverIut"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Comuna" } },
              [
                _c("b-form-input", {
                  attrs: {
                    "data-cy": "incident-commune",
                    name: "incidentCommune",
                    type: "text",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.incidentCommune,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "incidentCommune", $$v)
                    },
                    expression: "formData.incidentCommune"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Sector" } },
              [
                _c("b-form-input", {
                  attrs: {
                    "data-cy": "incident-sector",
                    name: "incidentSector",
                    type: "text",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.incidentSector,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "incidentSector", $$v)
                    },
                    expression: "formData.incidentSector"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label:
                    "Descripción (hora, calles, patente otro vehículo, celular, heridos)"
                }
              },
              [
                _c("b-form-textarea", {
                  attrs: {
                    "data-cy": "incident-description",
                    name: "incidentDescription",
                    type: "text",
                    rows: "3",
                    maxLength: "5000"
                  },
                  model: {
                    value: _vm.formData.incidentDescription,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "incidentDescription", $$v)
                    },
                    expression: "formData.incidentDescription"
                  }
                }),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formData.incidentDescription.length) +
                          "/5000 "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Observaciones" } },
              [
                _c("b-form-textarea", {
                  attrs: {
                    "data-cy": "observations",
                    name: "observations",
                    type: "text",
                    rows: "3",
                    maxLength: "5000"
                  },
                  model: {
                    value: _vm.formData.observations,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "observations", $$v)
                    },
                    expression: "formData.observations"
                  }
                }),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formData.observations.length) +
                          "/5000 "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm.error.message !== ""
      ? _c(
          "div",
          {
            staticClass:
              "con-text-validation span-text-validation-danger\n          vs-input--text-validation-span v-enter-to text-right",
            staticStyle: { height: "32px" }
          },
          [
            _c("span", { staticClass: "span-text-validation" }, [
              _vm._v(" " + _vm._s(_vm.error.message) + " ")
            ])
          ]
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "cancel",
              color: "primary",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.back()
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "save",
              color: "success",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.save()
              }
            }
          },
          [
            _vm._v(" Crear "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.saving,
                  expression: "saving"
                }
              ],
              staticClass: "spinner-border spinner-border-sm text-primary"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Destinos *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Pasajeros *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Carga combustible")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Informe de incidentes")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }